import {Component, inject, OnInit, signal} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Navbar } from './shared/components/navbar/navbar';
import { Sidebar } from './shared/components/sidebar/sidebar';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { LoaderTemplate } from './shared/components/loader-template/loader-template';
import { filter } from 'rxjs';
import { SidebarService } from './core/services/sidebar/sidebar-service';
import {FontLoaderService} from './core/services/font-loader/font-loader.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Navbar,
    Sidebar,
    NgxUiLoaderModule,
    LoaderTemplate,
    LoaderTemplate,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit{
  protected readonly title = signal('ciberseguridad-frontend-auth');

  constructor(private router: Router,
              private fontLoader: FontLoaderService) {
    this.currentPath = this.router.url;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentPath = event.urlAfterRedirects;
      });
  }
  currentPath: string = '';

  // rutas donde no mostrar el navbar y sidebar
  pathsWithoutNavbar: string[] = ['/', '/login', '/error'];

  isAllowedPath(): boolean {
    return !this.pathsWithoutNavbar.includes(this.currentPath);
  }
  ngOnInit(): void {
    document.fonts.ready.then(() => {
      document.body.classList.add('font-symbols-loaded');
    });
  }
  protected sidebarService = inject(SidebarService);
}
